import React from 'react';
import { Radio, Eye,  Search, Filter, AlertTriangle } from 'lucide-react';
import { Badge } from '../../ui/Badge';
import { TechnologyStack } from '../TechnologyStack'

import { Link, useNavigate } from 'react-router-dom'
// import { Port } from 'api-client';

interface Port {
  id: string;
  number: number;
  protocol: string;
  service: string;
  product: string;
  version: string;
  state: 'open' | 'closed' | 'filtered';
  last_seen: string;
  status?: string;
  technologies: any;
}

interface AssetPortsProps {
  ports: Port[];
}

export const AssetPorts: React.FC<AssetPortsProps> = ({ ports }) => {
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      {/* Filters */}
      <div className="flex items-center space-x-4">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 h-5 w-5" />
          <input
            type="text"
            placeholder="Search ports..."
            className="w-full pl-10 pr-4 py-2 bg-[#1A1F2E] border border-gray-800 rounded-lg text-gray-300 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          />
        </div>
        <button className="flex items-center space-x-2 px-4 py-2 bg-[#1A1F2E] border border-gray-800 rounded-lg text-gray-300 hover:bg-[#1A1F2E]/80 transition-colors">
          <Filter className="h-4 w-4" />
          <span>Filters</span>
        </button>
      </div>

      {/* Ports Table */}
      <div className="bg-[#0F1629] rounded-xl border border-gray-800/50 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-800">
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-400">Port</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-400">Protocol</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-400">Service</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-400">Technologies</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-400">Version</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-400">Status</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-400"></th>
               
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {ports.map((port) => (
                <tr key={port.id} className="group hover:bg-gray-800/30">
                  <td className="px-6 py-4 cursor-pointer" onClick={() => navigate(`/ports/${port.id}`)}>
                    <span className="text-sm font-medium text-white">{port.number}</span>
                  </td>
                  <td className="px-6 py-4">
                    <span className="text-sm text-gray-300">{port?.protocol?.toUpperCase() || ""}</span>
                  </td>
                  <td className="px-6 py-4">
                    <span className="text-sm text-gray-300">{port?.service?.toUpperCase() || ""}</span>
                  </td>
                  <td className="px-6 py-4">
                  <TechnologyStack
                    technologies={port.technologies}
                    maxVisible={3}
                  />
                  

                  </td>
                  <td className="px-6 py-4">
                  <span className="text-sm text-gray-300">{port?.version || ""}</span>
                  </td>
                  <td className="px-6 py-4">
                    <Badge variant={port?.state === 'open' ? 'open' : 'default'}>
                      {port?.state || ""}
                    </Badge>
                  </td>
                  <td className="px-6 py-4">
                  <Link
                      to={`/ports/${port.id}`}
                      className="bg-[#1A1F2E] text-white"
                    >
                      <Eye className="h-4 w-4" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};